module.exports = __webpack_public_path__ + "static/media/favicon-paloalto623.a65277ce.ico";